import React, {useState} from 'react'
import {FacetFilter} from '@findhotel/sapi'

import {Checkbox} from '@vio/atlas/Checkbox'
import {Box} from '@vio/atlas/helpers/Box'
import {Accordion} from '@vio/atlas/src/components/designSystem/Accordion'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {getVisibleFacetFilters} from '../utils'

const NEIGHBORHOOD_LIMIT = 3
interface Props {
  variant?: 'one-column' | 'two-columns'
  isExpandable?: boolean
  neighborhoods: FacetFilter[]
  selectedNeighborhoodIds: string[]
  onChange: (filterName: string, filterValue: string | null | undefined) => void
  limit?: number
}
export const NeighborhoodFilter: React.FC<Props> = ({
  variant = 'one-column',
  isExpandable = true,
  neighborhoods,
  selectedNeighborhoodIds,
  onChange,
  limit = NEIGHBORHOOD_LIMIT
}) => {
  const [isExpanded, setExpanded] = useState(false)

  const filteredNeighborhoodIds = getVisibleFacetFilters(
    neighborhoods,
    isExpandable,
    isExpanded,
    limit
  )

  return (
    <>
      <Box
        marginBottom="s400"
        display="grid"
        gap="s400"
        gridTemplateColumns={
          variant === 'one-column' ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'
        }
      >
        {filteredNeighborhoodIds.map(neighborhood => (
          <Checkbox
            key={neighborhood.id}
            name={neighborhood.value}
            value={neighborhood.id}
            checked={selectedNeighborhoodIds?.includes(neighborhood.id)}
            onChange={() => onChange('neighborhoodIds', neighborhood.id)}
            label={neighborhood.value}
            labelSize="bodyS"
          />
        ))}
      </Box>
      {isExpandable && (
        <Accordion
          isBottomAligned
          size="sm"
          header={
            isExpanded ? (
              <FormattedMessageWrapper
                id="showLess"
                defaultMessage="Show less"
              />
            ) : (
              <FormattedMessageWrapper
                id="showMore"
                defaultMessage="Show more"
              />
            )
          }
          onToggle={() => setExpanded(state => !state)}
        >
          <React.Fragment />
        </Accordion>
      )}
    </>
  )
}
